import { render } from "./SavedToSpendPage.vue?vue&type=template&id=3c341726&scoped=true"
import script from "./SavedToSpendPage.vue?vue&type=script&lang=js"
export * from "./SavedToSpendPage.vue?vue&type=script&lang=js"

import "./SavedToSpendPage.vue?vue&type=style&index=0&id=3c341726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c341726"]])

export default __exports__